const messages = {
  title: "Mis puntos",
  desc: "Aquí puedes consultar tu estado de puntos obtenidos en cada pedido. Su validez es de 1 año. El próximo 30 de marzo se reiniciará el contador, por lo que te aconsejamos que los canjees antes de esa fecha en la Tienda de Regalos.",
  score: "Saldo de puntos",
  regularPoints: "Puntos regulares",
  boosterPoints: "Puntos de bonificación",
  date: "Fecha",
  supplySourceReason: "Distribuidor / Bridgestone Plus",
  article: "Artículo",
  brand: "Marca",
  product: "Producto",
  type: "Tipo",
  inch: "Pulgada",
  season: "Temporada",
  amount: "Cantidad",
  standardPoints: "Puntos",
  boosterProduct: "Producto de bonificación",
  boosterSeason: "Temporada de bonificación",
  otherActions: "Acciones",
  totalPoints: "Total de puntos",
  income: "Ingresos",
  spending: "Gastos",
  lastMonth: "Saldo final",
  loadMore: "Cargar 20 transacciones más",
  typeFilter: "Filtrar por fuente",
  dateFilter: "Filtrar por periodo",
  customer_number: "Número de cliente",
  currentPoints: "Puntos actuales",
  calculationDate: "Fecha de cálculo",
  positivePoints: "Puntos positivos",
  negativePoints: "Ya gastados",
  tyresAmount: "Número de neumáticos por año",
  pointsTotal: "Total de puntos",
  currentPointState: "Estado actual de puntos",
  currentKickbackState: "Cashback actual",
  pointsFromCurrentYear: "Añadir: puntos del año en curso ({year})",
  pointsAtRiskOfExpiry: "Puntos por gastar antes del 31.03.{year}",
  points: "Puntos",
  noDataFound: "No se encontraron datos",
  seasons: {
    summer: "Verano",
    winter: "Invierno",
    all: "Todas las estaciones"
  },
};
export default {
  messages,
};
